import { Box, styled, SxProps } from "@mui/material";

interface Props {
  backgroundFillColor?: string;
  fillColor?: string;
  sx?: SxProps;
}

const LoadingDotsAnimated = (props: Props) => {
  const fillBackGround = props?.backgroundFillColor || "white";
  const fillColor = props?.fillColor || "#A16DFC";
  return (
    <Container sx={props?.sx}>
      <svg width="76" height="20" viewBox="0 0 76 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="76" height="20" fill={fillBackGround} />
        <circle cx="6" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="22" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="38" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="54" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="70" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
      </svg>
      <svg width="76" height="20" viewBox="0 0 76 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="76" height="20" fill={fillBackGround} />
        <circle cx="6" cy="6" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="22" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="38" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="54" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="70" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
      </svg>

      <svg width="76" height="20" viewBox="0 0 76 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="76" height="20" fill={fillBackGround} />
        <circle cx="6" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="22" cy="6" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="38" cy="10" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="54" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="70" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
      </svg>
      <svg width="76" height="20" viewBox="0 0 76 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="76" height="20" fill={fillBackGround} />
        <circle cx="6" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="22" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="38" cy="6" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="54" cy="10" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="70" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
      </svg>

      <svg width="76" height="20" viewBox="0 0 76 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="76" height="20" fill={fillBackGround} />
        <circle cx="6" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="22" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="38" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="54" cy="6" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="70" cy="10" r="6" fill={fillColor} fill-opacity="0.29" />
      </svg>
      <svg width="76" height="20" viewBox="0 0 76 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="76" height="20" fill={fillBackGround} />
        <circle cx="6" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="22" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="38" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="54" cy="14" r="6" fill={fillColor} fill-opacity="0.29" />
        <circle cx="70" cy="6" r="6" fill="#A16DFC" fill-opacity="0.29" />
      </svg>
    </Container>
  );
};
export default LoadingDotsAnimated;

const Container = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "76px",
  height: "20px",

  "& svg": {
    position: "absolute",
    width: "76px",
    height: "20px",
    opacity: 0,
    animation: "fade 1s infinite",
  },

  "& svg:nth-of-type(1)": {
    animationDelay: "0s",
  },
  "& svg:nth-of-type(2)": {
    animationDelay: "0.2s",
  },
  "& svg:nth-of-type(3)": {
    animationDelay: "0.4s",
  },
  "& svg:nth-of-type(4)": {
    animationDelay: "0.6s",
  },
  "& svg:nth-of-type(5)": {
    animationDelay: "0.8s",
  },
  "& svg:nth-of-type(6)": {
    animationDelay: "1s",
  },

  "@keyframes fade": {
    "0%": { opacity: 0 },
    "10%": { opacity: 1 },
    "20%": { opacity: 1 },
    "30%": { opacity: 0 },
    "100%": { opacity: 0 },
  },
}));
